export default __webpack_public_path__ + "Raleway-ExtraBold.ttf?cda3c9c91d02c73d1eb5d7752898f7cb";